import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../commonComponents/translate';
import CourseProp from '../propTypes/courseProp';
import Progress from './enrolledItem/Progress';
import Anchor from '../../../commonComponents/Anchor';
import AcademyFooterContainer from '../../../commonComponents/container/AcademyFooterContainer';
import CertificateIcon from '../../../commonComponents/icons/CertificateIcon';

const detailsLinkText = course => {
  if (course.progress === 0) {
    return 'start';
  }
  if (course.progress > 0 && course.progress < 100) {
    return 'continue';
  }
  return 'details';
};

function AcademyEnrolledCourse({ t, course, highlight, isDashboard }) {
  const { isRecommended } = course;
  const duration = moment.duration(course.duration);
  const hours = duration.days() > 0 ? (duration.days() * 24) + duration.hours() : duration.hours();
  const durationCompose = `${hours}h:${duration.minutes()}m`;

  const image = course.imageSquare || course.image;
  const imageURL = image ? image.thumb : '/image/no_image_upload.png';

  return (
    <div
      className={
        'm-portlet ' +
        'm-portlet--rounded ' +
        'm-portlet--rounded-force ' +
        'academy-enrolled-course-item ' +
        'academy-course-item' +
        `${highlight ? ' highlight-course-item' : ''}` +
        `${isDashboard ? ' dashboard-courses' : ''}`
      }
    >
      {isRecommended && isDashboard &&
        <div className={isRecommended && highlight ? 'isRecommended-white' : 'isRecommended'}>
          <h6>
            {t('inbox_courses_recommended')}
          </h6>
        </div>
      }
      <div className="enrolled-courses">
        <div className="enrolled-courses-image">
          <div className={`m-portlet__body course-container-body ${highlight ? 'highlight-course' : ''}`}>
            <Anchor
              itemProp="url"
              content={`/academy/${course.slug}`}
              href={`/academy/${course.slug}/play`}
              className="course-image course-play-button wide-play-button enrolled-image"
            >
              <img
                itemProp="image"
                content={imageURL}
                src={imageURL}
                alt="course"
              />
            </Anchor>
          </div>
        </div>
        <div className="enrolled-courses-content">
          <div className="course-details">
            <div className="course-header">
              <div className="course-header-name">{course.name}</div>
            </div>
            <div className="course-subheader course-enrolled-subheader">
              {duration > 0 && <AcademyFooterContainer faIcon="la la-clock-o" text={durationCompose} />}
              {course.certificate && course.certificate.isActive &&
                <AcademyFooterContainer
                  customIcon={<CertificateIcon />}
                  text={t('reward.certificate')}
                />
              }
              <Progress progress={course.progress} showLabel={false} />
            </div>
            <div
              className={
                'm-portlet__foot ' +
                'course-container-footer ' +
                'course-enrolled-container-footer' +
                `${highlight ? ' highlight-footer' : ''}`
              }
            >
              <Anchor
                href={`/academy/${course.slug}`}
                className="btn m-btn--pill btn-dynamic continue-button"
              >
                {t(detailsLinkText(course))}
              </Anchor>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

AcademyEnrolledCourse.propTypes = {
  t: PropTypes.func.isRequired,
  course: PropTypes.shape(CourseProp.propType).isRequired,
  highlight: PropTypes.bool,
  isDashboard: PropTypes.bool,
};

AcademyEnrolledCourse.defaultProps = {
  highlight: false,
  isDashboard: false,
};

export default translate(AcademyEnrolledCourse);
